module.exports = __webpack_public_path__ + "img/s-6.41682873.jpg";